<app-mid-right-panel [title]="'ACCESS_CODE.ACCESS_CODE' | translate">
  <app-mid-right-panel-content>
    <div class="row m-0 px-4 pb-4">
      <section class="section col-md-12 text-center">
        <qrcode [qrdata]="data.link" [width]="240" [errorCorrectionLevel]="'M'"></qrcode>
      </section>
    </div>
  </app-mid-right-panel-content>
</app-mid-right-panel>
